module.exports = __webpack_public_path__ + "img/spellbound_fountain_small.77c183e5.png";